import locale from "./innerPanel.locale";
export const TABS = [
    {
        key: "ATTRIBUTES",
        label: locale.ATTRIBUTES
    },
    {
        key: "METHODS",
        label: locale.METHODS
    },
    {
        key: "SCRIPTS",
        label: locale.SCRIPTS
    }
];
